import { Outlet, useLocation } from 'react-router-dom'
import Breadcrumb from '../../../cars/components/V3/_shared/Breadcrumb'
import { Stack } from '../../../cars/components/V3/_shared/Stack'
import Container from '../../../../components/Container'

interface BreadcrumbPath {
  path: string
  label: string
}

function ReportsLayout(): JSX.Element {
  const location = useLocation()

  const getBreadcrumbPaths = (): BreadcrumbPath[] => {
    const pathParts = location.pathname.split('/').filter(Boolean)

    if (pathParts.length === 1 && pathParts[0] === 'reports') {
      return []
    }

    const routeTranslate: Record<string, string> = {
      purchase: 'Kjøpsrapport',
      toll: 'Bompasseringer',
      environment: 'Miljørapport',
      fuel: 'Drivstoffrapport',
      invoice: 'Fakturarapport',
      leasing: 'Leasingrapport',
      fleet: 'Flåterapport',
      account: 'Konto',
      expense: 'Utgift',
      month: 'Måned',
    }

    const paths: BreadcrumbPath[] = [{ path: '/reports', label: 'Rapporter' }]

    let cumulativePath = '/reports'

    for (let i = 1; i < pathParts.length; i++) {
      cumulativePath += `/${pathParts[i]}`
      const label = decodeURIComponent(routeTranslate[pathParts[i]] || pathParts[i])
      paths.push({ path: cumulativePath, label })
    }

    return paths
  }

  const breadcrumbPaths = getBreadcrumbPaths()

  return (
    <Container isLoading={undefined}>
      <Stack>
        {breadcrumbPaths.length > 1 && <Breadcrumb paths={breadcrumbPaths} />}
        <Outlet />
      </Stack>
    </Container>
  )
}

export default ReportsLayout
